import styled from '@emotion/styled'
import * as React from 'react'
import { useRef, useState } from 'react'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import { ChordStyle, Orientation } from 'svguitar'
import { ChordEditor } from '../components/ChordEditor'
import { ChordForm } from '../components/ChordForm'
import { ChordResult } from '../components/ChordResult'
import DownloadButtons from '../components/DownloadButtons'
import { Frame } from '../components/Frame'
import ShareButtons from '../components/ShareButtons'
import { Chart } from '../domain/chart'
import { usePersistedState } from '../hooks/persisted-state'
import { useResizeHandler } from '../hooks/use-resize-handler'
import IndexLayout from '../layouts'
import '../styles/index.scss'

const initialSettings = Object.freeze({
  orientation: Orientation.vertical,
  style: ChordStyle.normal,
  strings: 6,
  frets: 5,
  position: 1,
  nutSize: 0.65,
  titleFontSize: 48,
  color: '#000',
  strokeWidth: 2,
  fretSize: 1.5,
  backgroundColor: 'none',
  fixedDiagramPosition: false
})

const ColCenterContent = styled(Col)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
`

const IndexPage = (props: { location: Location }) => {
  const chartRef = useRef<HTMLDivElement | null>(null)

  const [chart, setChart] = usePersistedState<Chart>('chart_v1', {
    chord: {
      fingers: [],
      barres: []
    },
    settings: initialSettings
  })
  const [size, setSize] = useState<{ width: number; height: number }>({ width: 0, height: 0 })
  const { width, height } = useResizeHandler()

  const resetSettings = () => setChart({ ...chart, settings: initialSettings })

  const {
    settings: { frets, strings }
  } = chart

  return (
    <IndexLayout location={props.location}>
      <h1>Генератор диаграмм гитарных аккордов</h1>
      <p>
        Создание диаграмм ещё никогда не было таким простым и быстрым! Для начала работы нажмите в любом месте на схеме гитарного грифа{' '}
        <a class="index-link-bold" href="#editor">
				<i>
          в редакторе
				</i>
        </a>{' '}
        — введённые данные сразу же отобразятся{' '}
        <a class="index-link-bold" href="#result">
			<i>
          на диаграмме
		  	</i>
        </a>{' '} в соседнем окне. <br />
		Созданную схему можно <a href="#download">скачать</a> или <a href="#share">поделиться ей в социальных сетях</a>.
      </p>

      <ChordForm onResetSettings={resetSettings} settings={chart.settings} onSettings={(settings) => setChart({ ...chart, settings })} />

      <Row className="my-5">
        <ColCenterContent md={6}>
          <Frame text="Редактор" id="editor">
            <ChordEditor
              width={width * 0.75}
              height={height * 0.6}
              numFrets={frets || initialSettings.frets}
              numStrings={strings || initialSettings.strings}
              settings={chart.settings}
              chord={chart.chord}
              onChart={(chart) => setChart(chart)}
            />
          </Frame>
        </ColCenterContent>
        <ColCenterContent md={6}>
          <Frame text="Диаграмма" stretch={true} id="result">
            <ChordResult
              chart={chart}
              chartRef={chartRef}
              onSize={setSize}
              onChangeOrienation={(orientation) => {
                setChart({
                  ...chart,
                  settings: {
                    ...chart.settings,
                    orientation
                  }
                })
              }}
            />
          </Frame>
        </ColCenterContent>
      </Row>
      <Row>
        <Col md={6}>
          <DownloadButtons chartRef={chartRef} size={size} title={chart.settings.title} />
        </Col>
        <Col md={6}>
          <ShareButtons chart={chart} />
        </Col>
      </Row>
    </IndexLayout>
  )
}

export default IndexPage
